import React, { Fragment } from 'react'
import { RadioGroup } from 'informed'

import { Select, Radio, Checkbox } from 'components/forms'
import Divider from 'components/Divider'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import loadAppConstants from 'gql/query/loadAppConstants'

export default ({ formApi, t, i18n }) => {
	return(
		<Fragment>
			<Select
				field='type'
				remoteOptions={{
					query: loadAppConstants,
					variables: { type: 74, language: i18n.language },
					modifyOptions: vals => vals.map(({ value, ...rest }) => ({ ...rest, value: Number(value) }))
				}}
				label={t('loyalty_card_section.fields.type')}
			/>
			<RadioGroup field='isActive'>
				<Radio label={t('loyalty_card_section.fields.all_cards')}/>
				<Radio value={true} label={t('loyalty_card_section.fields.active_cards')}/>
				<Radio value={false} label={t('loyalty_card_section.fields.inactive_cards')}/>
			</RadioGroup>
			<Divider height={40}/>
			<Checkbox label={t('loyalty_card_section.strings.hasPhoneNumber')} field='hasPhoneNumber'/>
			<Divider height={40}/>
			<DateIntervalForm field='lastTransaction' formApi={formApi} />
		</Fragment>
	)
}
